import Box from '@mui/material/Box';
import { useEffect, useRef, type RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingPage from '../Helper/LoadingPage/LoadingPage';

export interface RazorViewProps {
    initialContentHTML?: string;
    razorViewRef?: RefObject<HTMLDivElement | null>;
    afterSetHTML?: () => void;
}

const RazorView = ({
    initialContentHTML,
    razorViewRef,
    afterSetHTML,
}: RazorViewProps): React.ReactElement => {
    const innerRazorViewRef = useRef<HTMLDivElement>(null);
    const razorView = razorViewRef ?? innerRazorViewRef;
    const { t } = useTranslation();

    const setInnerHTML = (initialContentHTML: string): void => {
        if (!razorView.current) {
            throw new Error('Could not set RazorView content because ref is missing');
        }

        const razor = razorView.current;

        razor.innerHTML = initialContentHTML;

        Array.from(razor.querySelectorAll('script'))
            .forEach((oldScriptEl) => {
                const newScriptEl = document.createElement('script');

                Array.from(oldScriptEl.attributes).forEach((attr) => {
                    newScriptEl.setAttribute(attr.name, attr.value);
                });

                const scriptText = document.createTextNode(oldScriptEl.innerHTML);
                newScriptEl.appendChild(scriptText);

                oldScriptEl.parentNode?.replaceChild(newScriptEl, oldScriptEl);
            });

        afterSetHTML?.();
    };

    useEffect(() => {
        if (initialContentHTML) {
            setInnerHTML(initialContentHTML);
        }
    }, [initialContentHTML]);

    const isLoading = initialContentHTML == null;
    if (isLoading) {
        return <LoadingPage backGroundColor="#FFF" />;
    }

    return (
        <Box id="appLayout" className="razor-view">
            <Box id="content" sx={{ height: '100%' }}>
                <p title={t('Close')} onClick={() => window.closeActiveFile(true)} id="closeActiveFile" style={{ display: 'block' }}>{t('Close')}</p>
                <Box id="contentView" sx={{ height: '100%' }} ref={razorView} />
            </Box>
        </Box>
    );
};

export default RazorView;
